import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { FormContainer } from "../Base";
import { IDType, Invoice, PaymentData } from "../../../../apis/privatesell/enitites";
import { privateSellApi } from "../../../../apis/privatesell";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { CurrencyUtil, LocaleUtil } from "@eres/core";

interface Props {
	invoiceType: IDType;
	referenceNumber: string;
	updatePaymentLink: ( link: string ) => void;
}

interface State {
	payData?: PaymentData;
}

export default class InvoiceDetail extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		const oldData = prevProps.invoiceType;
		const newData = this.props.invoiceType;
		if ( oldData !== newData ) {
			this.loadInvoice();
		}
	}

	componentDidMount(): void {
		this.loadInvoice();
	}

	loadInvoice() {
		const { invoiceType, referenceNumber } = this.props;
		showLoading();
		const apiHandler = ( response: PaymentData ) => {
			hideLoading();
			this.setState( { payData: response }, () => {
				if ( response && response.paymentUrl )
					this.props.updatePaymentLink( response.paymentUrl );
			} );
		};
		const exHandler = ( reason: any ) => {
			hideLoading();
			if ( reason && reason.type && reason.type === "ValidationError" ) {
				showMessage( Strings.system_error + "\n" + reason.message );
			} else
				showMessage( reason.toString() );
		};
		privateSellApi.getInvoiceBy( referenceNumber, invoiceType.Id ).then( apiHandler ).catch( exHandler );
	}

	render() {
		const { payData } = this.state;
		return <div className={ "col-md-6 property-details content-section buyer-seller-invoice" }>
			{
				payData && payData.invoices.map( ( invoice: Invoice ) => {
					const title = LocaleUtil.getLocalValue( invoice.invoiceType ) + " (" + LocaleUtil.getLocalValue( invoice.invoicePayee ) + ") ";
					return <FormContainer title={ title }>
						<div className="flex-grid">
							{
								invoice && invoice.invoiceDetails.map( ( item, index ) => {
									return <div>
										<span data-uw-styling-context="true">{ LocaleUtil.getLocalValue( item.feeName ) }</span>
										<span data-uw-styling-context="true">{ CurrencyUtil.convertValueToCurrency( item.amount ) + " " + Strings.aed }</span>
									</div>;
								} )
							}
							{
								invoice && invoice.invoiceDetails.length > 0 &&
								<div className="font-weight-bold">
									<span data-uw-styling-context="true">{ Strings.payable_amount }</span>
									<span
										data-uw-styling-context="true">{ CurrencyUtil.convertValueToCurrency( payData.totalAmountPayable ) + " " + Strings.aed }</span>
								</div>
							}
						</div>
					</FormContainer>;
				} )
			}
		</div>;
	}
}
